<template>
    <b-table hover :items="items" :fields="fields" @row-clicked="onClickRow" table-class="text-nowrap" responsive>
        <template #cell(name)="data">
            <h4 class="mb-0">
                {{ data.item.name }}
            </h4>
        </template>
        <template #cell(category)="data">
            {{ data.item.category }}
        </template>
        <template #cell(strain)="data">
            {{ data.item.strain }}
        </template>
        <template #cell(qoh)="data">
            {{ data.item.qoh }}
        </template>
    </b-table>
</template>

<script>
export default {
    name: "AdminItemsTable",
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    methods: {
        onClickRow() {
            // Future action for row click - perhaps call a new AdminItem.vue template
            alert('row clicked');
        }
    },
    data() {
        return {
            fields: [
                { key: 'name', label: 'Item Name', thClass: "border-top-0", tdClass: "align-middle cursor-pointer" },
                { key: 'category', label: 'Category', thClass: "border-top-0", tdClass: "align-middle cursor-pointer" },
                { key: 'strain', label: 'Strain', thClass: "border-top-0", tdClass: "align-middle cursor-pointer" },
                { key: 'qoh', label: 'QoH', thClass: "border-top-0", tdClass: "align-middle cursor-pointer" }
            ]
        }
    }
}
</script>
